module.exports = __webpack_public_path__ + "img/thumbnail_Llama_f_normal.122e9c51.png";